module.exports = "https://trybtryb-legacy.web.app/img/torn-taupe.9f6d239b.webp";